import { authTypes } from "redux/types";

export const updateFreeZone = (payload) => {
  const next = {
    freeZone_id: payload?.id,
    port: payload?.port,
    name_freeZone: payload?.name_freeZone,
    nameFreeZoneTemp: payload?.shortName_freeZone,
    measure_revision_times: payload?.measure_revision_times,
    max_subheading_digits: payload?.max_subheading_digits,
  };
  if (payload?.code_dane != null && payload?.code_dane !== "") {
    next.code_dane_free_zone = payload.code_dane;
  }
  return {
    type: authTypes.updateFreeZone,
    payload: next,
  };
}

export default updateFreeZone;
